import React from 'react'
import config from '../../config'

const LogoBrand: React.FC = props => (
  <svg xmlns={config.xlmns} fill="currentColor" {...props}>
    <g fill="#214e78">
      <path d="m0 .4h10l16.2 25.2 16.1-25.2h10v53.2h-9.3v-38.2l-16.9 25.1h-.3l-16.6-24.9v38h-9.2z" />
      <path d="m73.6.4h39.4v8.4h-30.1v13.8h26.7v8.4h-26.7v14.3h30.5v8.4h-39.8z" />
      <path d="m132.1.4h19.8c16.7 0 28.3 11.5 28.3 26.4v.2c0 15-11.6 26.6-28.3 26.6h-19.8zm19.8 44.7c11.2 0 18.5-7.5 18.5-17.9v-.2c0-10.4-7.3-18.1-18.5-18.1h-10.5v36.2z" />
      <path d="m199.7.4h9.3v53.2h-9.3z" />
      <path d="m249.7 0h8.7l23.4 53.6h-9.9l-5.4-12.8h-25.2l-5.5 12.8h-9.6zm13.3 32.5-9.2-21.3-9.1 21.3z" />
      <path d="m328.8.4h9.3v44.7h28v8.5h-37.3z" />
      <path d="m384 .4h9.3v53.2h-9.3z" />
      <path d="m415.2.4h23.8c6.1 0 10.9 1.7 13.9 4.7 2.4 2.4 3.6 5.2 3.6 8.8v.2c0 6.4-3.6 9.8-7.6 11.9 6.2 2.1 10.6 5.7 10.6 12.9v.1c0 9.5-7.8 14.6-19.7 14.6h-24.6zm21.9 22.4c6 0 10-2.4 10-7.2v-.2c0-4.2-3.3-6.8-9.3-6.8h-13.5v14.1h12.8zm2.8 22.5c6.4 0 10.3-2.5 10.3-7.3v-.2c0-4.5-3.6-7.1-10.9-7.1h-14.8v14.6z" />
      <path d="m477.7.4h23.7c6.7 0 11.9 2 15.4 5.3 2.8 2.9 4.4 6.8 4.4 11.5v.2c0 8.7-5.2 14-12.7 16.1l14.4 20.1h-11l-13.2-18.6h-11.7v18.5h-9.3zm23 26.4c6.7 0 10.9-3.5 10.9-8.9v-.2c0-5.7-4.1-8.8-11-8.8h-13.6v17.9z" />
      <path d="m559.1 0h8.7l23.4 53.6h-9.9l-5.4-12.8h-25.2l-5.5 12.8h-9.6zm13.3 32.5-9.2-21.3-9.1 21.3z" />
      <path d="m607.8.4h23.7c6.7 0 11.9 2 15.4 5.3 2.8 2.9 4.4 6.8 4.4 11.5v.2c0 8.7-5.2 14-12.7 16.1l14.4 20.1h-11l-13.1-18.6h-11.7v18.5h-9.3v-53.1zm23.1 26.4c6.7 0 10.9-3.5 10.9-8.9v-.2c0-5.7-4.1-8.8-11-8.8h-13.6v17.9z" />
      <path d="m684.1 32.6-21.1-32.2h11l14.9 23.6 15-23.6h10.7l-21.1 32v21.2h-9.4z" />
    </g>
  </svg>
)

export default LogoBrand
